import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth/authSlice";
import adminBackgroundReducer from "./slices/adminBackgroundSlice/adminBackgroundSlice";
import paymentSourceTypeReducer from "./slices/paymentSourceType/paymentSourceTypeSlice";
import myStripePaymentReducer from "./slices/myStripePayment/myStripePaymentSlice";
import planTypeReducer from "./slices/planType/planTypeSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  adminBackground: adminBackgroundReducer,
  paymentSource: paymentSourceTypeReducer,
  myStripePayment: myStripePaymentReducer,
  planType: planTypeReducer,
});

// Persist configuration
const persistConfig = {
  key: "root",
  version: 1,
  storage,
};
// create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);
// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// create persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
